import { Mat4 } from '../../core/math/mat4.js';
import { Vec3 } from '../../core/math/vec3.js';
import { PRIMITIVE_LINES } from '../../platform/graphics/constants.js';
import { Mesh } from '../mesh.js';
import { MeshInstance } from '../mesh-instance.js';
import { GraphNode } from '../graph-node.js';

const identityGraphNode = new GraphNode();
identityGraphNode.worldTransform = Mat4.IDENTITY;
identityGraphNode._dirtyWorld = identityGraphNode._dirtyNormal = false;
class ImmediateBatch {
	constructor(device, material, layer) {
		this.material = material;
		this.layer = layer;
		this.positions = [];
		this.colors = [];
		this.tAndLength = [];
		this.mesh = new Mesh(device);
		this.meshInstance = null;
		this.helperA = new Vec3();
		this.helperB = new Vec3();
	}
	addLines(positions, color) {
		const destPos = this.positions;
		const destTAndLength = this.tAndLength;
		const count = positions.length;
		for (let i = 0; i < count - 1; i += 2) {
			const pos1 = positions[i];
			const pos2 = positions[i + 1];
			destPos.push(pos1.x, pos1.y, pos1.z);
			destPos.push(pos2.x, pos2.y, pos2.z);
			const length = pos2.distance(pos1);
			destTAndLength.push(0, length);
			destTAndLength.push(1, length);
		}
		const destCol = this.colors;
		if (color.length) {
			for (let i = 0; i < count; i++) {
				const col = color[i];
				destCol.push(col.r, col.g, col.b, col.a);
			}
		} else {
			for (let i = 0; i < count; i++) {
				destCol.push(color.r, color.g, color.b, color.a);
			}
		}
	}
	addLinesArrays(positions, color) {
		const destPos = this.positions;
		const destTAndLength = this.tAndLength;
		for (let i = 0; i < positions.length - 5; i += 6) {
			destPos.push(positions[i], positions[i + 1], positions[i + 2]);
			this.helperA.set(positions[i], positions[i + 1], positions[i + 2]);
			destPos.push(positions[i + 3], positions[i + 4], positions[i + 5]);
			this.helperB.set(positions[i + 3], positions[i + 4], positions[i + 5]);
			const length = this.helperB.distance(this.helperA);
			destTAndLength.push(0, length);
			destTAndLength.push(1, length);
		}
		const destCol = this.colors;
		if (color.length) {
			for (let i = 0; i < color.length - 3; i += 4) {
				destCol.push(color[i], color[i + 1], color[i + 2], color[i + 3]);
			}
		} else {
			const count = positions.length / 3;
			for (let i = 0; i < count; i++) {
				destCol.push(color.r, color.g, color.b, color.a);
			}
		}
	}
	onPreRender(visibleList, transparent) {
		if (this.positions.length > 0 && this.material.transparent === transparent) {
			this.mesh.setPositions(this.positions);
			this.mesh.setUvs(0, this.tAndLength);
			this.mesh.setColors(this.colors);
			this.mesh.update(PRIMITIVE_LINES, false);
			if (!this.meshInstance) {
				this.meshInstance = new MeshInstance(this.mesh, this.material, identityGraphNode);
			}
			visibleList.push(this.meshInstance);
		}
	}
	clear() {
		this.positions.length = 0;
		this.colors.length = 0;
		this.tAndLength.length = 0;
	}
}

export { ImmediateBatch };
